import {
    faSolidAnchor,
    faSolidAngleLeft,
    faSolidAngleRight,
    faSolidAngleUp,
    faSolidAnglesLeft,
    faSolidAnglesRight,
    faSolidArrowDown,
    faSolidArrowRightArrowLeft,
    faSolidArrowRightFromBracket,
    faSolidArrowRightToBracket,
    faSolidArrowRotateLeft,
    faSolidArrowsRotate,
    faSolidArrowsTurnToDots,
    faSolidBan,
    faSolidBars,
    faSolidBatteryEmpty,
    faSolidBatteryFull,
    faSolidBell,
    faSolidBellSlash,
    faSolidBolt,
    faSolidBoltLightning,
    faSolidBook,
    faSolidBox,
    faSolidBoxArchive,
    faSolidBoxOpen,
    faSolidBoxesStacked,
    faSolidBriefcase,
    faSolidBug,
    faSolidBuilding,
    faSolidBullhorn,
    faSolidCalculator,
    faSolidCalendarCheck,
    faSolidCar,
    faSolidCaretDown,
    faSolidCaretUp,
    faSolidCashRegister,
    faSolidChartBar,
    faSolidChartColumn,
    faSolidCheck,
    faSolidCircle,
    faSolidCircleCheck,
    faSolidCircleExclamation,
    faSolidCircleInfo,
    faSolidCirclePlay,
    faSolidCircleQuestion,
    faSolidCircleStop,
    faSolidCircleUser,
    faSolidCircleXmark,
    faSolidClipboardList,
    faSolidClock,
    faSolidClone,
    faSolidCompress,
    faSolidCube,
    faSolidDatabase,
    faSolidDownload,
    faSolidEnvelope,
    faSolidEnvelopeCircleCheck,
    faSolidEnvelopeOpen,
    faSolidExclamation,
    faSolidExpand,
    faSolidEye,
    faSolidEyeSlash,
    faSolidFerry,
    faSolidFile,
    faSolidFileCircleQuestion,
    faSolidFileCircleXmark,
    faSolidFileContract,
    faSolidFileCsv,
    faSolidFileExcel,
    faSolidFileInvoiceDollar,
    faSolidFileLines,
    faSolidFilePdf,
    faSolidFilter,
    faSolidFilterCircleXmark,
    faSolidFire,
    faSolidFireFlameCurved,
    faSolidFloppyDisk,
    faSolidGauge,
    faSolidGear,
    faSolidHammer,
    faSolidHand,
    faSolidHouse,
    faSolidInbox,
    faSolidKey,
    faSolidLanguage,
    faSolidLayerGroup,
    faSolidLightbulb,
    faSolidLink,
    faSolidList,
    faSolidListCheck,
    faSolidLocationDot,
    faSolidLock,
    faSolidLockOpen,
    faSolidMagnifyingGlass,
    faSolidMaximize,
    faSolidMoon,
    faSolidPaperPlane,
    faSolidPaperclip,
    faSolidPassport,
    faSolidPaste,
    faSolidPenToSquare,
    faSolidPersonMilitaryPointing,
    faSolidPlaneArrival,
    faSolidPlaneDeparture,
    faSolidPlay,
    faSolidPlus,
    faSolidPrint,
    faSolidQuestion,
    faSolidSailboat,
    faSolidScrewdriverWrench,
    faSolidShare,
    faSolidShield,
    faSolidShieldHalved,
    faSolidShip,
    faSolidStop,
    faSolidSun,
    faSolidTableColumns,
    faSolidTags,
    faSolidThumbsDown,
    faSolidThumbsUp,
    faSolidThumbtack,
    faSolidTicket,
    faSolidTrain,
    faSolidTrash,
    faSolidTriangleExclamation,
    faSolidTruck,
    faSolidTruckRampBox,
    faSolidUpload,
    faSolidUser,
    faSolidUserPlus,
    faSolidUsers,
    faSolidWarehouse,
    faSolidWaterLadder,
    faSolidXmark
} from '@ng-icons/font-awesome/solid';

import {
    bootstrapApple,
    bootstrapEnvelopePaperFill,
    bootstrapFacebook,
    bootstrapGoogle
} from '@ng-icons/bootstrap-icons';

const icons: Record<string, string> = {
    bootstrapApple,
    bootstrapEnvelopePaperFill,
    bootstrapFacebook,
    bootstrapGoogle,
    faSolidAnchor,
    faSolidAngleLeft,
    faSolidAngleRight,
    faSolidAnglesLeft,
    faSolidAnglesRight,
    faSolidAngleUp,
    faSolidArrowDown,
    faSolidArrowRightArrowLeft,
    faSolidArrowRightFromBracket,
    faSolidArrowRightToBracket,
    faSolidArrowRotateLeft,
    faSolidArrowsRotate,
    faSolidArrowsTurnToDots,
    faSolidBan,
    faSolidBars,
    faSolidBatteryEmpty,
    faSolidBatteryFull,
    faSolidBell,
    faSolidBellSlash,
    faSolidBolt,
    faSolidBoltLightning,
    faSolidBook,
    faSolidBox,
    faSolidBoxArchive,
    faSolidBoxOpen,
    faSolidBoxesStacked,
    faSolidBriefcase,
    faSolidBug,
    faSolidBuilding,
    faSolidBullhorn,
    faSolidCalculator,
    faSolidCar,
    faSolidCaretDown,
    faSolidCaretUp,
    faSolidCalendarCheck,
    faSolidCashRegister,
    faSolidChartBar,
    faSolidChartColumn,
    faSolidCheck,
    faSolidCircle,
    faSolidCircleCheck,
    faSolidCircleExclamation,
    faSolidCircleInfo,
    faSolidCircleQuestion,
    faSolidCirclePlay,
    faSolidCircleStop,
    faSolidCircleUser,
    faSolidCircleXmark,
    faSolidClipboardList,
    faSolidClock,
    faSolidClone,
    faSolidCompress,
    faSolidCube,
    faSolidDatabase,
    faSolidDownload,
    faSolidEnvelope,
    faSolidEnvelopeCircleCheck,
    faSolidEnvelopeOpen,
    faSolidExclamation,
    faSolidExpand,
    faSolidEye,
    faSolidEyeSlash,
    faSolidFerry,
    faSolidFile,
    faSolidFileExcel,
    faSolidFileCircleQuestion,
    faSolidFileCircleXmark,
    faSolidFileContract,
    faSolidFileCsv,
    faSolidFileInvoiceDollar,
    faSolidFileLines,
    faSolidFilePdf,
    faSolidFilter,
    faSolidFilterCircleXmark,
    faSolidFire,
    faSolidFireFlameCurved,
    faSolidFloppyDisk,
    faSolidGauge,
    faSolidGear,
    faSolidHammer,
    faSolidHand,
    faSolidHouse,
    faSolidInbox,
    faSolidKey,
    faSolidLanguage,
    faSolidLightbulb,
    faSolidLink,
    faSolidList,
    faSolidListCheck,
    faSolidLocationDot,
    faSolidLock,
    faSolidLockOpen,
    faSolidLayerGroup,
    faSolidMagnifyingGlass,
    faSolidMaximize,
    faSolidMoon,
    faSolidPaperclip,
    faSolidPaperPlane,
    faSolidPassport,
    faSolidPaste,
    faSolidPenToSquare,
    faSolidPersonMilitaryPointing,
    faSolidPlaneArrival,
    faSolidPlaneDeparture,
    faSolidPlus,
    faSolidPlay,
    faSolidPrint,
    faSolidQuestion,
    faSolidSailboat,
    faSolidScrewdriverWrench,
    faSolidShare,
    faSolidShield,
    faSolidShieldHalved,
    faSolidShip,
    faSolidStop,
    faSolidSun,
    faSolidTableColumns,
    faSolidTags,
    faSolidThumbsDown,
    faSolidThumbsUp,
    faSolidThumbtack,
    faSolidTicket,
    faSolidTrain,
    faSolidTrash,
    faSolidTriangleExclamation,
    faSolidTruck,
    faSolidTruckRampBox,
    faSolidUpload,
    faSolidUser,
    faSolidUserPlus,
    faSolidUsers,
    faSolidWarehouse,
    faSolidWaterLadder,
    faSolidXmark
};

export default icons;

export type IconKey =
    | 'bootstrapApple'
    | 'bootstrapEnvelopePaperFill'
    | 'bootstrapFacebook'
    | 'bootstrapGoogle'
    | 'faSolidAnchor'
    | 'faSolidAngleLeft'
    | 'faSolidAngleRight'
    | 'faSolidAnglesLeft'
    | 'faSolidAnglesRight'
    | 'faSolidAngleUp'
    | 'faSolidArrowDown'
    | 'faSolidArrowRightArrowLeft'
    | 'faSolidArrowRightFromBracket'
    | 'faSolidArrowRightToBracket'
    | 'faSolidArrowRotateLeft'
    | 'faSolidArrowsRotate'
    | 'faSolidArrowsTurnToDots'
    | 'faSolidBan'
    | 'faSolidBars'
    | 'faSolidBatteryEmpty'
    | 'faSolidBatteryFull'
    | 'faSolidBell'
    | 'faSolidBellSlash'
    | 'faSolidBolt'
    | 'faSolidBoltLightning'
    | 'faSolidBook'
    | 'faSolidBox'
    | 'faSolidBoxArchive'
    | 'faSolidBoxOpen'
    | 'faSolidBoxesStacked'
    | 'faSolidBriefcase'
    | 'faSolidBug'
    | 'faSolidBuilding'
    | 'faSolidBullhorn'
    | 'faSolidCalculator'
    | 'faSolidCar'
    | 'faSolidCaretDown'
    | 'faSolidCaretUp'
    | 'faSolidCalendarCheck'
    | 'faSolidCashRegister'
    | 'faSolidChartBar'
    | 'faSolidChartColumn'
    | 'faSolidCheck'
    | 'faSolidCircle'
    | 'faSolidCircleCheck'
    | 'faSolidCircleExclamation'
    | 'faSolidCircleInfo'
    | 'faSolidCircleQuestion'
    | 'faSolidCirclePlay'
    | 'faSolidCircleStop'
    | 'faSolidCircleUser'
    | 'faSolidCircleXmark'
    | 'faSolidClipboardList'
    | 'faSolidClock'
    | 'faSolidClone'
    | 'faSolidCompress'
    | 'faSolidCube'
    | 'faSolidDatabase'
    | 'faSolidDownload'
    | 'faSolidEnvelope'
    | 'faSolidEnvelopeCircleCheck'
    | 'faSolidEnvelopeOpen'
    | 'faSolidExclamation'
    | 'faSolidExpand'
    | 'faSolidEye'
    | 'faSolidEyeSlash'
    | 'faSolidFerry'
    | 'faSolidFile'
    | 'faSolidFileExcel'
    | 'faSolidFileCircleQuestion'
    | 'faSolidFileCircleXmark'
    | 'faSolidFileContract'
    | 'faSolidFileCsv'
    | 'faSolidFileInvoiceDollar'
    | 'faSolidFileLines'
    | 'faSolidFilePdf'
    | 'faSolidFilter'
    | 'faSolidFilterCircleXmark'
    | 'faSolidFire'
    | 'faSolidFireFlameCurved'
    | 'faSolidFloppyDisk'
    | 'faSolidGauge'
    | 'faSolidGear'
    | 'faSolidHammer'
    | 'faSolidHand'
    | 'faSolidHouse'
    | 'faSolidInbox'
    | 'faSolidKey'
    | 'faSolidLanguage'
    | 'faSolidLightbulb'
    | 'faSolidLinks'
    | 'faSolidList'
    | 'faSolidListCheck'
    | 'faSolidLocationDot'
    | 'faSolidLock'
    | 'faSolidLockOpen'
    | 'faSolidLayerGroup'
    | 'faSolidMagnifyingGlass'
    | 'faSolidMaximize'
    | 'faSolidMoon'
    | 'faSolidPaperclip'
    | 'faSolidPaperPlane'
    | 'faSolidPassport'
    | 'faSolidPaste'
    | 'faSolidPenToSquare'
    | 'faSolidPersonMilitaryPointing'
    | 'faSolidPlaneArrival'
    | 'faSolidPlaneDeparture'
    | 'faSolidPlus'
    | 'faSolidPlay'
    | 'faSolidPrint'
    | 'faSolidQuestion'
    | 'faSolidSailboat'
    | 'faSolidScrewdriverWrench'
    | 'faSolidShare'
    | 'faSolidShield'
    | 'faSolidShieldHalved'
    | 'faSolidShip'
    | 'faSolidStop'
    | 'faSolidSun'
    | 'faSolidTableColumns'
    | 'faSolidTags'
    | 'faSolidThumbsDown'
    | 'faSolidThumbsUp'
    | 'faSolidThumbtack'
    | 'faSolidTicket'
    | 'faSolidTrain'
    | 'faSolidTrash'
    | 'faSolidTriangleExclamation'
    | 'faSolidTruck'
    | 'faSolidTruckRampBox'
    | 'faSolidUpload'
    | 'faSolidUser'
    | 'faSolidUserPlus'
    | 'faSolidUsers'
    | 'faSolidWarehouse'
    | 'faSolidWaterLadder'
    | 'faSolidXmark';
